import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { RFNodeIcon, RFSvg } from '../../base';
import { RFConfigContext } from '../../../contexts';
import { useNodeTemplate } from '../../../hooks';
import { CAT_CRACKING_RR_CONFIG } from './RFCatCrackingRRNode.config';
/**
 * Component renders "catCrackingRRBlock" type of node of ReactFlow.
 * @param props : props come from ReactFlow.
 * See RF_NODE_TYPES.
 */
const RFCatCrackingReactorNodeFC = ({ id, data, type, isConnectable = true, selected }) => {
    const { isInspector } = useContext(RFConfigContext) ?? {};
    const { isValidTemplate, renderPorts, renderError } = useNodeTemplate({
        id,
        selected,
        templateCode: data.templateCode,
        config: CAT_CRACKING_RR_CONFIG
    });
    return isValidTemplate ? (_jsxs(Flex, { "data-templateid": data.templateCode, flexDirection: "column", gap: "4px", children: [_jsxs(RFNodeIcon, { id: id, rfType: type, isSelected: selected, isInspector: isInspector, templateCode: data.templateCode ?? '', children: [_jsx(RFSvg, { name: CAT_CRACKING_RR_CONFIG.icon, width: 69, height: 102 }), renderPorts(isConnectable, isInspector)] }), _jsx(Box, { maxW: "60px", fontSize: "12px", lineHeight: "14px", fontWeight: 700, className: "cut-text", children: data.title })] })) : (_jsx(_Fragment, { children: renderError() }));
};
export const RFCatCrackingRRNode = RFCatCrackingReactorNodeFC;
//# sourceMappingURL=RFCatCrackingRRNode.js.map